exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-531ec560]{display:flex;width:100%}.column.half[data-v-531ec560]{width:50%}.notice[data-v-531ec560]{justify-content:center;border-bottom:1px solid #e5e4e5;background:#fff}.notice>div[data-v-531ec560]{padding:20px}.notice>div img[data-v-531ec560],.notice>div p[data-v-531ec560]{line-height:1em;display:inline-block;vertical-align:middle;font-size:14px}.notice>div p[data-v-531ec560]{margin:0;background:linear-gradient(-100deg,hsla(58,92%,75%,.4),hsla(58,92%,75%,.8) 95%,hsla(58,92%,75%,.2))}.notice>div img[data-v-531ec560]{height:1.8em;margin-right:5px}@media (max-width:979px){.row.notice>div[data-v-531ec560]{padding:20px}}@media (max-width:767px){.row .column.half[data-v-531ec560]{width:100%}.row.notice>div[data-v-531ec560]{padding:20px;text-align:center}.row.notice>div p[data-v-531ec560]{font-size:10px;display:unset}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-531ec560","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/notice/style.scss
// module id = 863
// module chunks = 0